// extracted by mini-css-extract-plugin
module.exports = {"cd":"CountdownTimerSticky_cd__i62Tw"};